export default "/images/header.png?c02fcf9c2c39f0603e292ecc87180101";